import { defineMessages } from 'react-intl-next';

export const unarchivePagesRestrictionWarningsI18n = defineMessages({
	unarchiveInheritedRestrictionsNoChildrenWarningTitle: {
		id: 'archive-pages.unarchive.restrictions.inherited.no-children.title',
		defaultMessage: 'Access to this item will change',
		description:
			'Title of the warning message shown when a page with inherited restrictions is being unarchived without its children',
	},
	unarchiveInheritedRestrictionsNoChildrenWarningMessage: {
		id: 'archive-pages.unarchive.restrictions.inherited.no-children.message',
		defaultMessage:
			'This item is restricted by a parent. After restoring, its access will be based on its new position in the content tree. <a>Learn more about inherited restrictions</a>',
		description:
			'Message shown when a page with inherited restrictions is being unarchived without its children',
	},
	unarchiveInheritedRestrictionsWithChildrenWarningTitle: {
		id: 'archive-pages.unarchive.restrictions.inherited.with-children.title',
		defaultMessage: 'Access to restored items will change',
		description:
			'Title of the warning message shown when a page with inherited restrictions is being unarchived with its children',
	},
	unarchiveInheritedRestrictionsWithChildrenWarningMessage: {
		id: 'archive-pages.unarchive.restrictions.inherited.with-children.message',
		defaultMessage:
			'These items are restricted by a parent. After restoring, their access will be based on their new position in the content tree. <a>Learn more about inherited restrictions</a>',
		description:
			'Message shown when a page with inherited restrictions is being unarchived with its children',
	},
	unarchiveOwnRestrictionsNoChildrenWarningTitle: {
		id: 'archive-pages.unarchive.restrictions.own.no-children.title',
		defaultMessage: 'Access to remaining nested items will change',
		description:
			'Title of the warning message shown when a page with its own restrictions is being unarchived without its children',
	},
	unarchiveOwnRestrictionsNoChildrenWarningMessage: {
		id: 'archive-pages.unarchive.restrictions.own.no-children.message',
		defaultMessage:
			'These items are restricted by the parent you’re restoring. After restoring, their access will be based on their new position in the archive. <a>Learn more about inherited restrictions</a>',
		description:
			'Message shown when a page with its own restrictions is being unarchived without its children',
	},
});
